<app-plusmore-logo></app-plusmore-logo>
<div class="parent-container">
  <form (ngSubmit)="login()" [formGroup]="loginFormGroup">
    <div class="login-form">
      <span class="title"
        >Enter username to register a customer for +more loyalty</span
      >
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input
          matInput
          placeholder="Username"
          formControlName="username"
          required
        />
      </mat-form-field>
      <app-action-button
        class="action-button"
        [text]="'CONTINUE'"
        [style]="'flat'"
        [disabled]="!loginFormGroup.valid"
        [fullWidth]="true"
        type="submit"
      ></app-action-button>
    </div>
  </form>
</div>
<span class="version">version: {{ environment.version }}</span>
